import { FormatNumberWithCommas } from "../../../../../shared/scripts/number-functions";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../../shared/scripts/table-column-visibility";
import { RenderDateMDY, RenderDateYMD, RenderDays } from "../../../../../shared/scripts/table-functions";
import { ContractHistory } from "../../scripts/contracts.entities";


export class ContractHistoryTab {

    tableId: string = "contracts-history-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;

    constructor(contracts: ContractHistory[]) {

        let columns: any[] = [
            { data: "ContractType", title: "Contract Type", className: "category text-left font-size12 nowrap" },
            { data: { _: "ContractNameDisplay", sort: "ContractName" }, title: "Contract Name", className: "text-left font-size12" },
            { data: "ContractNumber", title: "Contract Number", className: "contract-number text-left font-size12 nowrap" },
            { data: "PrimeContract", title: "Prime Contract", className: "prime-contract text-left font-size12 nowrap" },
            { data: "StatusGroup", title: "Status Group", className: "status-group text-left font-size12 nowrap" },
            { data: "Status", title: "Status", className: "status text-left font-size12 nowrap" },
            { data: "DateStatusStart", title: "Status Start Date", className: "start-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "DateStatusEnd", title: "Status End Date", className: "end-date text-center font-size12 nowrap", render: RenderDateMDY },
            { data: "Duration", title: "Duration", className: "duration text-center font-size12 nowrap", render: RenderDays },
            //{ data: "ActualEndDate", title: "End Date<br>(Actual)", className: "end-dates text-center font-size12", width: '100px', render: RenderDateYMD },
            { data: "SortDate", title: "SortOrder", visible: false },
        ];

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [[9, 'asc']],
            data: contracts
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), [
            new TableColumnGroup("Contract Number", false, [], "contract-number"),
            new TableColumnGroup("Prime Contract", false, [], "prime-contract"),
            new TableColumnGroup("Status Group", false, [], "status-group"),
            new TableColumnGroup("Status", true, [], "status"),
            new TableColumnGroup("Start Date", true, [], "start-date"),
            new TableColumnGroup("End Date", true, [], "end-date"),
            new TableColumnGroup("Duration", true, [], "duration"),
        ]);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(contracts.length);
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Records Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Record Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Records Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    updateContent(matchingContracts: ContractHistory[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(matchingContracts).draw();
        this.setCountFoundLabel(matchingContracts.length);
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }
}